import { InboxRouteConfig } from '/@/modules/inbox/routes/InboxRouteConfig';
import { InboxRoute } from '/@/modules/inbox/routes/inbox.routes';

export const router = [
  InboxRouteConfig.factory({
    path: `/${InboxRoute.DASHBOARD.path}`,
    name: InboxRoute.DASHBOARD.name,
    component: () => import('/@/modules/inbox/pages/InboxDashboardPage.vue')
  }).build()
];
